"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PopupOrder = void 0;
var _react = _interopRequireDefault(require("react"));
var _Button = require("../../Button");
var _PopupOrderList = require("../../PopupOrderList");
var _getPrefixCls = require("../../../utils/getPrefixCls");
var _ic_close = _interopRequireDefault(require("../../../assets/images/ic_close.svg"));
var _reactSvg = require("react-svg");
var _constants = require("../constants");
var PopupOrder = function PopupOrder(props) {
  var _props$value2;
  var active = props.active,
    setActive = props.setActive,
    panelTitleText = props.panelTitleText,
    popupContainer = props.popupContainer,
    onLoadMore = props.onLoadMore,
    userTypes = props.userTypes,
    stillNotFoundButtonText = props.stillNotFoundButtonText,
    stillNotFoundValueText = props.stillNotFoundValueText,
    componentTrackingData = props.componentTrackingData;
  var PREFIX = (0, _getPrefixCls.getPrefixCls)('popup-order');
  var onOrderSelect = function onOrderSelect(order) {
    var _props$onChange;
    (_props$onChange = props.onChange) === null || _props$onChange === void 0 ? void 0 : _props$onChange.call(props, order.data);
    setActive(false);
  };
  var onRemoveOrder = function onRemoveOrder(e) {
    var _e$stopPropagation, _props$onChange2;
    e === null || e === void 0 ? void 0 : (_e$stopPropagation = e.stopPropagation) === null || _e$stopPropagation === void 0 ? void 0 : _e$stopPropagation.call(e);
    (_props$onChange2 = props.onChange) === null || _props$onChange2 === void 0 ? void 0 : _props$onChange2.call(props);
  };
  var onClickStillNotFound = function onClickStillNotFound() {
    var _props$onChange3;
    (_props$onChange3 = props.onChange) === null || _props$onChange3 === void 0 ? void 0 : _props$onChange3.call(props, {
      orderSn: "".concat(_constants.STILL_NOT_FOUND_ORDER_ID),
      orderId: _constants.STILL_NOT_FOUND_ORDER_ID
    });
    setActive(false);
  };
  var onOrderClick = function onOrderClick() {
    var _props$value, _props$value$handleOr;
    (_props$value = props.value) === null || _props$value === void 0 ? void 0 : (_props$value$handleOr = _props$value.handleOrderDetailRedirect) === null || _props$value$handleOr === void 0 ? void 0 : _props$value$handleOr.call(_props$value);
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, props.value ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, ((_props$value2 = props.value) === null || _props$value2 === void 0 ? void 0 : _props$value2.orderId) === -1 ? /*#__PURE__*/_react.default.createElement("div", null, stillNotFoundValueText) : /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(PREFIX, "-value"),
    onClick: onOrderClick
  }, /*#__PURE__*/_react.default.createElement("img", {
    className: "".concat(PREFIX, "-value__img"),
    src: props.value.image
  }), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(PREFIX, "-value__title")
  }, props.value.title), /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(PREFIX, "-value__spec")
  }, props.value.specification, "\xA0"), /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(PREFIX, "-value__price")
  }, props.value.totalPrice)), !props.readOnly && /*#__PURE__*/_react.default.createElement(_reactSvg.ReactSVG, {
    className: "".concat(PREFIX, "-value__close"),
    src: _ic_close.default,
    onClick: onRemoveOrder
  }))) : /*#__PURE__*/_react.default.createElement(_Button.Button, {
    className: "".concat(PREFIX, "-button"),
    text: "Select Order",
    type: "primary-outlined",
    onClick: function onClick() {
      setActive(true);
    }
  }), /*#__PURE__*/_react.default.createElement(_PopupOrderList.PopupOrderList, {
    showStillNotFound: true,
    className: "".concat(PREFIX, "-modal"),
    showUserTypeTab: true,
    panelTitleText: panelTitleText,
    active: active,
    onLoadMore: onLoadMore,
    onClose: function onClose(e) {
      e === null || e === void 0 ? void 0 : e.stopPropagation();
      setActive(false);
    },
    container: popupContainer,
    userTypes: userTypes,
    onSelectClick: onOrderSelect,
    onClickStillNotFound: onClickStillNotFound,
    stillNotFoundButtonText: stillNotFoundButtonText,
    componentTrackingData: componentTrackingData
  }));
};
exports.PopupOrder = PopupOrder;